.footer {
  width: 100%;
}
